import "core-js/modules/es.array.push.js";
import { $h, Tips, basePost, baseTokenPost, U, baseGet, URL, SplitArray, urlParams } from '@/utils/util.js';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
export default {
  props: {
    xzmenu: {
      type: Number,
      value: 1
    }
  },
  data() {
    return {
      xzmenuid: 0,
      userinfo: {
        xingming: '',
        uid: 0
      },
      //用户信息
      zrctoken: '',
      search_name: '',
      //搜索的关键词
      peizhiinfo: {}
    };
  },
  methods: {
    //进入到具体的活动点位
    menugo: function (path) {
      var that = this;
      router.push({
        path: path
      });
    },
    menuMouseEnter(id) {
      console.log('鼠标进入了元素');
      var that = this;
      that.xzmenuid = id;
      // 可以在这里添加逻辑，比如改变元素的样式或状态  
    },
    menuMouseLeave() {
      console.log('鼠标离开了元素');
      var that = this;
      that.xzmenuid = 0;
      // 可以在这里添加逻辑，比如恢复元素的样式或状态  
    },
    //这里是获取登录状态
    getdengluzt: function () {
      var that = this;
      that.zrctoken = store.state.zrctoken;
      console.log('这里是获取登录状态that.zrctoken' + that.zrctoken);
      if (that.zrctoken.length > 0)
        //正常获取到了token
        {
          var url = U({
            m: 'zrcwebapi/user',
            c: 'webuser_api',
            a: 'getuserinfo'
          }, URL);
          var data = {
            zrctoken: that.$data.zrctoken
          };
          baseTokenPost(that.$data.zrctoken, url, data, function (res) {
            that.userinfo = res.data.info.userinfo;
          });
        }
    },
    //这里是理解立即退出
    lijituichu: function () {
      var that = this;
      that.zrctoken = store.state.zrctoken;
      if (that.zrctoken.length > 0)
        //正常获取到了token
        {
          var url = U({
            m: 'zrcwebapi/user',
            c: 'webuser_api',
            a: 'goout'
          }, URL);
          var data = {};
          baseTokenPost(that.$data.zrctoken, url, data, function (res) {
            Tips('退出成功', 'success');
            store.commit('SetZrctoken', '');
            router.push({
              path: '/login'
            });
          });
        }
    },
    //基本配置
    getpeizhi: function () {
      var that = this;
      var url = U({
        m: 'zrcwebapi',
        c: 'webpublic_api',
        a: 'getpeizhi'
      }, URL);
      baseGet(url, function (res) {
        that.peizhiinfo = res.data.info.peizhiinfo;
      });
    },
    //进入到新闻列表
    goxwlist: function (id, xzmenu) {
      var that = this;
      router.push({
        path: '/newslist',
        query: {
          id: id,
          xzmenu: xzmenu
        }
      });
    },
    //进入到具体的新闻内容
    goxinwen: function (id, xzmenu) {
      var that = this;
      router.push({
        path: '/newsdetail',
        query: {
          id: id,
          xzmenu: xzmenu
        }
      });
    }
  },
  mounted: function () {
    var that = this;
    that.getdengluzt();
    that.getpeizhi(); //基本配置
  }
};